// JS
import React, { useState, useEffect } from 'react';
import Flickity from 'react-flickity-component';
import 'flickity-imagesloaded';
import { useMediaQuery } from 'react-responsive';
import {
  renderHTMLspan,
  renderHTML,
  getInternationalPriceNuqlium,
  getCookieValue,
  checkImgPath,
  ppHeadingOverridesClose
} from '../shared/utils';

// NUQLIUM API SETTINGS
import { nuqliumApiFunc } from '../shared/jsonData';

// COMPS
import { AddToBag } from './AddToBag';
import KlarnaNew from '../KlarnaNew';

// COMPONENT
const ProductRecommendationsPopup = ({
  quickViewProdId,
  setQuickViewProdId,
  showHideQuickView,
  setShowHideQuickView,
  setSelected,
  userSession,
  useURLParameter = false
}) => {
  const [data, setData] = useState(null);
  const [nuqliumApi, setNuqliumApi] = useState(null);
  const [fadeIn, setFadeIn] = useState('');
  const [prodSku, setProdSku] = useState(null);
  const [sizeSelect, setSizeSelect] = useState(null);
  const [sizeError, setSizeError] = useState('');
  const [, setDesktopFlickity] = useState(null);
  const [, setMobFlickity] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [size, setSize] = useState(null);
  const [atbButtonTxt, setAtbButtonTxt] = useState('Select Size');

  // Media Query
  const isMobile = useMediaQuery({ maxWidth: 767 });

  // Mini Basket - Preview
  const [miniBasketSize, setMiniBasketSize] = useState(null);
  const [miniBasketProdSku, setMiniBasketProdSku] = useState(null);

  // Modal - Scroll & No Scroll
  const [modalScrollPRQV, setModalScrollPRQV] = useState(false);

  const scrollModalClosedPRQV = () => {
    setModalScrollPRQV(false);
    // Scroll - Modal Closed
    document.body.style.overflow = 'unset';
  };

  const scrollModalShowPRQV = () => {
    setModalScrollPRQV(true);
    // No Scroll - Modal Open
    if (typeof window != 'undefined' && window.document) {
      document.body.style.overflow = 'hidden';
    }
  };

  useEffect(() => {
    if (quickViewProdId) {
      setNuqliumApi(nuqliumApiFunc(quickViewProdId));
    }
  }, [quickViewProdId]);

  useEffect(() => {
    if (nuqliumApi) {
      fetch(nuqliumApi.endPointUrl, {
        method: 'POST',
        body: nuqliumApi.endPointPrams
      })
        .then((response) => response.json())
        .then((data) => {
          if (data && data?.data?.products?.products[0]) {
            setData(data.data.products.products[0]);
            setCurrency(data.data.pricelist.currency);
            setFadeIn('animate-fadeIn');
            scrollModalShowPRQV();
          }
        });
    }
  }, [nuqliumApi]);

  const flickityOptionsMob = {
    pageDots: true,
    lazyLoad: 2,
    wrapAround: true,
    dragThreshold: 0,
    imagesLoaded: true,
    adaptiveHeight: true
  };

  const flickityOptionsDesktop = {
    pageDots: true,
    lazyLoad: 2,
    wrapAround: true,
    imagesLoaded: true,
    adaptiveHeight: true
  };

  const closeQuickViewCleanUp = () => {
    setShowHideQuickView(false);
    setData(null);
    setQuickViewProdId(null);
    setFadeIn('animate-fadeOut');
    setSizeSelect(null);
    setSelected(null);
    setSize(null);
    scrollModalClosedPRQV();
    ppHeadingOverridesClose();
  };

  const checkForColour = (data) => {
    if (data.facolour) {
      return data.facolour[0].toLowerCase();
    } else if (data.colour) {
      return data.colour[0].toLowerCase();
    }
  };

  return (
    <>
      {showHideQuickView && modalScrollPRQV && data && (
        <>
          <link
            rel="stylesheet"
            href="https://cdn.jsdelivr.net/npm/flickity@2/dist/flickity.min.css"
            type="text/css"
          />
          <div
            id="product-recommendations-quick-view"
            className={isMobile ? 'fade-in-up' : 'animate-fadeIn'}
            onClick={(e) => {
              if (e.currentTarget === e.target && !isMobile) {
                setTimeout(() => {
                  closeQuickViewCleanUp();
                }, '400');
                document.getElementById(
                  'product-recommendations-quick-view'
                ).className = isMobile ? 'fade-out-down' : 'animate-fadeOut';
              }
            }}
          >
            <div
              className={`product-recommendations-quick-view-carousel ${fadeIn}`}
              id="fadeInWrapper"
            >
              <div
                id="closeQuickViewButton"
                onClick={() => {
                  setTimeout(() => {
                    closeQuickViewCleanUp();
                  }, '400');
                  document.getElementById(
                    'product-recommendations-quick-view'
                  ).className = isMobile ? 'fade-out-down' : 'animate-fadeOut';
                }}
              >
                {renderHTML(null, 'close')}
              </div>
              <div className="product-recommendations-quick-view-container">
                <div className="product-recommendations-quick-view-row">
                  <div className="product-recommendations-quick-view-column desktop">
                    <div className="product-recommendations-quick-view-content">
                      {!isMobile && (
                        <Flickity
                          className={'carousel'}
                          elementType={'div'}
                          options={flickityOptionsDesktop}
                          flickityRef={(c) => setDesktopFlickity(c)}
                        >
                          {data.product.attributes.alternatives.map(
                            (slide, i) => (
                              <div
                                className="product-recommendations-quick-view-carousel-cell"
                                key={`cell[${i}]`}
                              >
                                <img
                                  data-flickity-lazyload={checkImgPath(slide)}
                                  alt={`${data.product.name} [${i}]`}
                                />
                              </div>
                            )
                          )}
                        </Flickity>
                      )}
                    </div>
                  </div>

                  <div className="product-recommendations-quick-view-column">
                    <div className="product-recommendations-quick-view-content information">
                      {isMobile && (
                        <Flickity
                          className={'carousel'}
                          elementType={'div'}
                          options={flickityOptionsMob}
                          flickityRef={(c) => {
                            setMobFlickity(c);
                            window.flickityInstance = c;
                          }}
                        >
                          {data.product.attributes.alternatives.map(
                            (slide, i) => (
                              <div
                                className="product-recommendations-quick-view-carousel-cell"
                                key={`cell[${i}]`}
                              >
                                <img
                                  data-flickity-lazyload={checkImgPath(slide)}
                                  alt={`${data.product.name} [${i}]`}
                                />
                              </div>
                            )
                          )}
                        </Flickity>
                      )}

                      {/* PRODUCT DETAILS */}
                      <div className="product-recommendations-quick-view-content-details">
                        <div className="flex justify-between gap-x-2 my-0 mx-0 lg:mb-7 relative">
                          <div className="flex flex-col w-[70%]">
                            <h3 className="product-title">
                              <span className="brand-name">
                                {data.product.attributes.brand}
                              </span>
                              <span className="product-name">
                                {data.product.name}
                              </span>
                            </h3>
                            <p className="product-colour hidden md:block">
                              {checkForColour(data.product.attributes)}
                            </p>
                          </div>

                          {data.product.option.price ===
                          data.product.option.promotionprice ? (
                            <div className="flex flex-col w-[30%]">
                              <div className="flex items-end justify-end">
                                <div className="product-price">
                                  {renderHTMLspan(data.product.option.price)}
                                </div>
                              </div>
                              <div className="product-price code hidden md:block">
                                Code: {renderHTMLspan(data.product.productid)}
                              </div>
                            </div>
                          ) : (
                            <div className="flex flex-col w-[30%]">
                              <div className="flex flex-col items-end flex-wrap gap-x-2 justify-end">
                                <div className="product-price rrp">
                                  {renderHTMLspan(data.product.option.price)}
                                </div>
                                <div className="product-price sale">
                                  {renderHTMLspan(
                                    data.product.option.promotionprice
                                  )}
                                </div>
                              </div>
                              <div className="product-price code hidden md:block">
                                Code: {renderHTMLspan(data.product.productid)}
                              </div>
                            </div>
                          )}
                        </div>

                        {/* KLARNA */}
                        {!isMobile &&
                          (getInternationalPriceNuqlium() === 'retail_gbp' ||
                            getInternationalPriceNuqlium() ===
                              'retail_eur') && (
                            <KlarnaNew
                              data={data}
                              currency={getCookieValue('currencypref')}
                              enableOverrides={false}
                              disableOverrides={false}
                            />
                          )}
                        {/* KLARNA */}

                        {/* PRODUCT SIZES */}
                        <div className="product-sizes product-recommendations-quick-view-product-sizes">
                          <div className="product-sizes-button hidden md:block">
                            <p>Sizes</p>
                          </div>

                          <div className="sizes-scroll-wrapper m-0 md:mt-0 md:mb-7">
                            {data.product.options.map((sizes, i) => (
                              <div
                                key={`sizes[${i}]`}
                                tabIndex="0"
                                role="button"
                                aria-pressed={
                                  sizes.sku === sizeSelect ? 'true' : 'false'
                                }
                                aria-label="Select a size"
                                data-sku={sizes.sku}
                                className={
                                  sizes.stock <= 0
                                    ? 'size-wrapper disabled'
                                    : sizes.sku === sizeSelect
                                    ? 'size-wrapper selected'
                                    : 'size-wrapper ' + sizeError
                                }
                                onClick={() => {
                                  setSizeSelect(sizes.sku);
                                  setProdSku(sizes.sku);
                                  //setSize(sizes.attributes.size);
                                  //setMiniBasketSize(sizes.attributes.size[0]);
                                  setSize(sizes.attributes.non_mapped_size);
                                  setMiniBasketSize(
                                    sizes.attributes.non_mapped_size[0]
                                  );
                                  setMiniBasketProdSku(sizes.sku);
                                  setAtbButtonTxt('Add to bag');
                                  setSizeError(''); // Clear size error
                                }}
                                onMouseOver={() => {
                                  setSizeError(''); // Clear size error
                                }}
                              >
                                <span className="size-value">
                                  {/*{sizes.attributes.size}*/}
                                  {sizes.attributes.non_mapped_size}
                                </span>
                              </div>
                            ))}
                          </div>
                        </div>
                        {/* PRODUCT SIZES */}

                        {/* ADD TO BAG */}
                        <AddToBag
                          sizeError={sizeError}
                          prodSku={prodSku}
                          setProdSku={setProdSku}
                          sizeSelect={sizeSelect}
                          setSizeSelect={setSizeSelect}
                          setSizeError={setSizeError}
                          prodData={data}
                          currency={currency}
                          size={size}
                          userSession={userSession}
                          // Mini Basket Preview
                          miniBasketSize={miniBasketSize}
                          miniBasketProdSku={miniBasketProdSku}
                          miniBasketProdIdData={data.product.productid}
                          closeQuickViewCleanUp={closeQuickViewCleanUp}
                          atbButtonTxt={atbButtonTxt}
                          setAtbButtonTxt={setAtbButtonTxt}
                        />
                        {/* ADD TO BAG */}

                        {/* FULL PRODUCT DETAIL */}
                        <div className="product-recommendations-quick-view-more-details">
                          <a
                            className="product-recommendations-quick-view-more-details-icon"
                            href={
                              useURLParameter
                                ? data.product.url + '?src=react'
                                : data.product.url + userSession
                            }
                          >
                            Full Product Detail
                          </a>
                        </div>
                      </div>
                      {/* PRODUCT DETAILS */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ProductRecommendationsPopup;
